export const CHANGE_IS_VALID = "CHANGE_IS_VALID";
export const SET_ON_SUBMIT = "SET_ON_SUBMIT";
export const SET_DIALOG = "SET_DIALOG";
export const RESET_DIALOG = "RESET_DIALOG";

export const changeIsValid = (isValid) => ({
  type: CHANGE_IS_VALID,
  payload: isValid,
});

export const setOnSubmit = (method) => ({
  type: SET_ON_SUBMIT,
  payload: method,
});

export const setDialog = (options) => ({
  type: SET_DIALOG,
  payload: options,
});

export const resetDialog = () => ({
  type: RESET_DIALOG,
});
